import type { JSX } from 'react';

/**
 * A Mermaid source as a plain code block, styled like every other code block in chat: the fallback
 * while the drawing code loads, while a reply streams, and when the source does not parse.
 */
export function MermaidCode({ source }: { source: string }): JSX.Element {
  return (
    <pre className="my-3 overflow-x-auto rounded-xl bg-[#1e1e1e] px-4 py-3 text-compact leading-relaxed text-[#d4d4d4]">
      <code className="language-mermaid">{source}</code>
    </pre>
  );
}
